/**
 * License operations for CDP SDK.
 */

import { CDPSession, getSession } from '../session';

export class LicenseManager {
  constructor(private readonly session: CDPSession = getSession()) {}

  async getLicense(): Promise<Record<string, any>> {
    return this.session.get('/api/license');
  }

  async checkLicense(licenseKey: string): Promise<Record<string, any>> {
    return this.session.post('/api/license/check', { data: { licenseKey } });
  }

  async getExpireInfo(): Promise<Record<string, any>> {
    return this.session.get('/api/license/expire');
  }

  async uploadLicense(licenseKey: string): Promise<Record<string, any>> {
    return this.session.post('/api/license', { data: { licenseKey } });
  }
}
